import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Bodytext } from '../../Typography';
import styled from '../../utils/styling/styled-components';
import { StyledHeading } from './styled-components';

var Value = function Value(_ref) {
  var value = _ref.value;

  if (value.length <= 11) {
    return /*#__PURE__*/React.createElement(StyledHeading, {
      fontSize: '22px'
    }, value);
  } else if (value.toString().length <= 15) {
    return /*#__PURE__*/React.createElement(StyledHeading, {
      fontSize: '16px'
    }, value);
  }

  return /*#__PURE__*/React.createElement(StyledHeading, {
    fontSize: '12px'
  }, value);
};

var StyledBodytext = styled(Bodytext)(_templateObject());
export var StandardContent = function StandardContent(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      testId = _ref2.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId !== null && testId !== void 0 ? testId : "".concat(label, "_value")
  }, /*#__PURE__*/React.createElement(Value, {
    value: value
  }), label && /*#__PURE__*/React.createElement(StyledBodytext, null, label));
};